document.querySelectorAll('.rich-text__collapsible[data-max-height]').forEach(function(collapsible) {
  var maxHeight = parseInt(collapsible.dataset.maxHeight);
  var btnWrap = collapsible.parentElement.querySelector('.rich-text__read-more-wrap');
  var btn = btnWrap ? btnWrap.querySelector('.rich-text__read-more') : null;

  function checkHeight() {
    var isBlank = collapsible.textContent.trim() === '';
    if (isBlank || collapsible.scrollHeight <= maxHeight) {
      if (btnWrap) btnWrap.hidden = true;
      collapsible.style.maxHeight = '';
      collapsible.classList.remove('rich-text__collapsible--collapsed');
    } else {
      if (btnWrap) btnWrap.hidden = false;
      if (collapsible.classList.contains('rich-text__collapsible--collapsed')) {
        collapsible.style.maxHeight = maxHeight + 'px';
      }
    }
  }

  if (btn) {
    btn.addEventListener('click', function() {
      if (collapsible.classList.contains('rich-text__collapsible--collapsed')) {
        collapsible.style.maxHeight = collapsible.scrollHeight + 'px';
        collapsible.classList.remove('rich-text__collapsible--collapsed');
        btn.textContent = 'Read less';
        btn.setAttribute('aria-expanded', 'true');
        collapsible.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName === 'max-height') {
            collapsible.style.maxHeight = 'none';
            collapsible.removeEventListener('transitionend', onEnd);
          }
        });
      } else {
        collapsible.style.maxHeight = collapsible.scrollHeight + 'px';
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            collapsible.style.maxHeight = maxHeight + 'px';
            collapsible.classList.add('rich-text__collapsible--collapsed');
            btn.textContent = 'Read more';
            btn.setAttribute('aria-expanded', 'false');
          });
        });
      }
    });
  }

  function debounce(fn, delay) {
    var t;
    return function() { clearTimeout(t); t = setTimeout(fn, delay); };
  }

  checkHeight();
  window.addEventListener('load', checkHeight);
  window.addEventListener('resize', debounce(checkHeight, 200));
});
